import {ONLINECOURSEHOST_ACCENT_COLOR, ONLINECOURSEHOST_PRIMARY_COLOR} from './ui-constants';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';
import {WebsiteBrand} from '../models/website-brand.model';


export const DEFAULT_THEME: WebsiteBrand = {
  primaryColor: ONLINECOURSEHOST_PRIMARY_COLOR,
  accentColor: ONLINECOURSEHOST_ACCENT_COLOR,
  salesPageBannerColor: ONLINECOURSEHOST_PRIMARY_COLOR
};



export function checkIfPlatformSite() {

  const hostName = document.location.host;

  return hostName.startsWith("app.") && hostName.includes(environment.domainName);

}

export function checkIfSingleSignOnPage() {

  const hostName = document.location.host;

  return hostName.startsWith("login") && hostName.includes(environment.domainName);

}

export function createTenantLoginUrl(startInCoursesPage = false, tenantId: string, redirectUrl?: string) {

  const currentPageEncodedUrl = encodeURIComponent(window.location.href),
    coursesPageEncodedUrl = encodeURIComponent(`${window.location.protocol}//${window.location.host}/courses`);

  let tenantLoginUrl = `${environment.authenticationUrl}?redirectUrl=`;

  if (startInCoursesPage) {
    tenantLoginUrl += coursesPageEncodedUrl;
  } else if (redirectUrl) {
    tenantLoginUrl += `${window.location.protocol}//${window.location.host}/${redirectUrl}`;
  } else {
    tenantLoginUrl += currentPageEncodedUrl;
  }

  if (tenantId) {
    tenantLoginUrl += `&tenantId=${tenantId}`;
  }

  return tenantLoginUrl;

}

export const goToLoginPage = (router: Router, startInCoursesPage = false, tenantId:string, redirectUrl?:string) => {

  if (checkIfPlatformSite()) {
    router.navigateByUrl('/platform-login');
    return;
  }

  const tenantLoginUrl = createTenantLoginUrl(startInCoursesPage, tenantId, redirectUrl);

  window.location.href = tenantLoginUrl;

}
